
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonImg,
  IonButtons,
  IonBackButton,
} from "@ionic/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseLayout",
  props: {
    title: {
      type: String,
      default: "",
    },
    hideBackBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonImg,
    IonButtons,
    IonBackButton,
  },
});
